import React from 'react';
import Chart from 'react-apexcharts';

const LineChart = ({ title, categories, series, colors, height = 350 }) => {
    const options = {
        chart: {
            type: 'line',
            height: height,
            zoom: {
                enabled: false
            },
            toolbar: {
                show: false
            }
        },
        stroke: {
            curve: 'smooth',
            width: 3
        },
        colors: colors || ['#8B5CF6'],
        markers: {
            size: 5,
        },
        xaxis: {
            categories: categories || [],
        }
    };

    return (
        <div className="bg-white p-4 rounded-lg shadow">
            {title && <h3 className="text-lg font-medium text-gray-900 mb-4">{title}</h3>}
            <Chart
                options={options}
                series={series || []}
                type="line"
                height={height}
            />
        </div>
    );
};

export default LineChart;